import { render, staticRenderFns } from "./SelectArtifact.vue?vue&type=template&id=4f816363&scoped=true&"
import script from "./SelectArtifact.vue?vue&type=script&lang=ts&"
export * from "./SelectArtifact.vue?vue&type=script&lang=ts&"
import style0 from "./SelectArtifact.vue?vue&type=style&index=0&id=4f816363&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f816363",
  null
  
)

export default component.exports